import React from "react";
import Card from "../../../components/card/Card";
import ModalMsg from "../../../components/ModalMsg";
import NsFileUploader from "../../../components/fields/NsFileUploader";
import NsField from "../../../components/fields/NsField";

export default function UploadDocumentiKpiView({
                                                   show,
                                                   setShow,
                                                   modalMsg,
                                                   descrizione,
                                                   setDescrizione,
                                                   files,
                                                   setFiles,
                                                   url,
                                                   idTipoImport,
                                                   bottoniSx,
                                                   bottoniDx,
                                                   handlePostUpload,
                                                   handleDeleteDocumento,
                                               }) {

    return (
        <Card
            icon={'fas fa-file-alt'}
            title={'Upload Documenti KPI'}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        >
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <form className="row g-3">
                <div className="col-md-12">
                    <NsField
                        name={"descrizione"}
                        label={"Descrizione:"}
                        valoreNoFormik={descrizione}
                        onChange={event => setDescrizione(event.target.value)}
                    />
                </div>
                <div className="col-md-12">
                    <NsFileUploader
                        files={files}
                        setFiles={setFiles}
                        allowMultiple={false}
                        allowRevert={true}
                        endpointPost={url + '?descrizione=' + descrizione + '&id_tipo_imp_dati=' + idTipoImport}
                        endpointDelete={url}
                        handlerPost={handlePostUpload}
                        handlerDelete={handleDeleteDocumento}
                    />
                </div>
            </form>
        </Card>
    )
}